import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type InitialState = {
    showDetail: boolean
}

const initialState: InitialState = {
    showDetail: false
}

const sensorState = createSlice({
    name: "sensorState",
    initialState,
    reducers: {
        setShowDetail: (state, action: PayloadAction<InitialState>) => {
            state.showDetail = action.payload.showDetail;
        }
    },

})

const sensorReducer = sensorState.reducer;
export default sensorReducer;
export const { setShowDetail } = sensorState.actions;